import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import {AuthGuard} from './@shared/services/auth.guard';

const routes: Routes = [
  { path: '', loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule) },
  { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
  { path: 'export', loadChildren: () => import('./@pages/export/export.module').then(m => m.ExportModule) },
  { 
    path: 'category-comparison/:categoryId/:currentMonth', 
    canActivate: [AuthGuard],
    loadChildren: () => import('./@pages/category-comparison/category-comparison.module').then(m => m.CategoryComparisonPageModule) 
  },
  { 
    path: 'tag-comparison/:tagId/:currentMonth', 
    canActivate: [AuthGuard],
    loadChildren: () => import('./@pages/tag-comparison/tag-comparison.module').then(m => m.TagComparisonPageModule) 
  },
  // { path: 'dashboard/:categoryID/:date', canActivate: [AuthGuard],
  //   loadChildren: () => import('./@pages/dashboard/dashboard-detail/dashboard-detail.module').then( m => m.DashboardDetailPageModule) },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
